import * as React from 'react';
import * as Select from 'react-select';
import './../ViewStyles/Select.css';

interface IFIASelectProps {
    value: any
    onInputChange?: (s: string) => void
    onChange: (o: any) => void
    options?: any
    placeholder: string
    multi: boolean
    name: string
    onNewTag?: () => void
    loadOptions?: any
    isAsync?: boolean,
    searchable?: boolean
    inputValue?: string
}

export default class FIASelect extends React.Component<IFIASelectProps>{

    public render() {
        const { isAsync, onNewTag } = this.props
        const S = isAsync ? Select.Async : Select.default
        return (
            <S
                style={{ border: 'none', fontWeight: 200, borderBottom: '1px solid #000', borderRadius: 0, marginTop: 30 }}
                wrapperStyle={{ width: '100%' }}
                noResultsText="Совпадений не найдено"
                onInputKeyDown={(e) => e.key === '/' ? onNewTag ? onNewTag() : null : null}
                {...this.props}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/abstract/Views/Select.tsx